module.exports = __webpack_public_path__ + "img/txt-b-1@2x.ef5fdab3.png";